import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
// import registerServiceWorker from "./registerServiceWorker";
import { unregister } from "./registerServiceWorker";
import configureStore from "./store/configureStore";
import { PersistGate } from "redux-persist/integration/react";

// import registerServiceWorker from "./registerServiceWorker";

const { persistor, store } = configureStore();
function noop() {}

// if (process.env.NODE_ENV !== "development") {
// }
const app = (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));

unregister();

// registerServiceWorker();
